// extracted by mini-css-extract-plugin
export default {"listItemLink":"styles__listItemLink__Txz2J","caption":"styles__caption__F72y4"};